import { useState, useEffect } from "react";
import { Folder, ChevronRight, Home, ArrowLeft } from "lucide-react";
import { listFiles } from "../../utils/api";
import Modal from "../Modal/Modal";

import "./FolderPicker.css";

export default function FolderPicker({ excludeId, onSelect, onClose }) {
    const [stack, setStack] = useState([{ id: null, name: "My Files" }]);
    const [folders, setFolders] = useState([]);
    const [loading, setLoading] = useState(false);

    const current = stack[stack.length - 1];

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            try {
                const res = await listFiles(current.id);
                setFolders(
                    res.data.filter(
                        (f) => f.type === "folder" && f._id !== excludeId,
                    ),
                );
            } catch (e) {
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [current.id, excludeId]);

    const navigateInto = (folder) => {
        setStack((prev) => [...prev, { id: folder._id, name: folder.name }]);
    };

    const navigateBack = () => {
        if (stack.length > 1) setStack((prev) => prev.slice(0, -1));
    };

    const navigateTo = (index) => {
        setStack((prev) => prev.slice(0, index + 1));
    };

    return (
        <Modal title="Move to…" onClose={onClose}>
            <div className="folder-picker">
                <div className="fp-breadcrumbs">
                    {stack.map((crumb, i) => (
                        <span key={i} className="fp-crumb-wrap">
                            {i > 0 && (
                                <ChevronRight size={13} className="fp-sep" />
                            )}
                            <button
                                className={`fp-crumb ${i === stack.length - 1 ? "active" : ""}`}
                                onClick={() => navigateTo(i)}
                            >
                                {i === 0 ? <Home size={13} /> : null}
                                {crumb.name}
                            </button>
                        </span>
                    ))}
                </div>

                <div className="fp-list">
                    {stack.length > 1 && (
                        <button
                            className="fp-item fp-back"
                            onClick={navigateBack}
                        >
                            <ArrowLeft size={16} />
                            <span>Back</span>
                        </button>
                    )}
                    {loading ? (
                        <div className="fp-empty">Loading…</div>
                    ) : folders.length === 0 ? (
                        <div className="fp-empty">No subfolders here</div>
                    ) : (
                        folders.map((folder) => (
                            <div key={folder._id} className="fp-item">
                                <button
                                    className="fp-item-name"
                                    onClick={() => navigateInto(folder)}
                                >
                                    <Folder size={18} />
                                    <span>{folder.name}</span>
                                    <ChevronRight
                                        size={15}
                                        className="fp-arrow"
                                    />
                                </button>
                                <button
                                    className="fp-select-btn"
                                    onClick={() =>
                                        onSelect({
                                            id: folder._id,
                                            name: folder.name,
                                        })
                                    }
                                >
                                    Move here
                                </button>
                            </div>
                        ))
                    )}
                </div>

                <div className="fp-footer">
                    <button className="btn-secondary" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        className="btn-primary"
                        onClick={() =>
                            onSelect({ id: current.id, name: current.name })
                        }
                    >
                        Move to "{current.name}"
                    </button>
                </div>
            </div>
        </Modal>
    );
}
